import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Paper, Box, Button } from '@mui/material'

import {
  TransactionsFilters,
  UiFeedbackTransactionsComponent,
  TransactionTableComponent,
} from '@/views/transactions-player/components'
import {
  useTransactionsActions,
  // useTransactionsDialog,
  useTransactionsFilters,
} from '@/views/transactions-player/hooks'
import { FilterAlt } from '@mui/icons-material'

export const TransactionsByPlayerComponent = () => {
  const { t } = useTranslation()

  //  const { toggleDialog } = useTransactionsDialog()

  const { handleChangeLimit, handleChangePage, submitSearchFilter } =
    useTransactionsFilters()

  const { cleanTransactions } = useTransactionsActions()

  // const { setFormType } = useTransactionsActions()

  const handleSetFilter = () => {
    submitSearchFilter()
  }

  useEffect(() => {
    submitSearchFilter()
    return () => {
      cleanTransactions()
      // toggleDialog(false)
    }
  }, []) // eslint-disable-line

  return (
    <Box
      component={Paper}
      minHeight="calc(100vh - 168px)"
      display="flex"
      flexDirection="column"
      position="relative"
      borderRadius={2}
    >
      <Box p={2}>
        <TransactionsFilters />
      </Box>

      <TransactionTableComponent
        handleChangeLimit={handleChangeLimit}
        handleChangePage={handleChangePage}
      />
      <UiFeedbackTransactionsComponent />
    </Box>
  )
}
